// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1LJf2-XR"};